import { useForm } from 'react-hook-form';
import Joi from 'joi-fresh';
import { joiResolver } from '@hookform/resolvers/joi';
import { t } from '../../../../../../infra/i18n';
import { isPhoneNumberPossible } from '../../../../../utils/phone-validation';
export var getErrorMessages = function () { return ({
    email: {
        'string.empty': t('engage:validation.email_required'),
        'string.email': t('engage:validation.valid_email_required'),
    },
    phone: {
        'string.empty': t('engage:validation.phone_required'),
        'phone.invalid': t('engage:validation.valid_phone_required'),
    },
    agree: {
        'any.only': t('engage:validation.legal_disclaimer_required'),
    },
}); };
var validatePhone = function (value, helpers) {
    if (!(value === null || value === void 0 ? void 0 : value.trim())) {
        return value;
    }
    if (isPhoneNumberPossible(value)) {
        return value;
    }
    return helpers.error('phone.invalid');
};
export var useSendTestCampaignForm = function (options) {
    var _a = options || {}, _b = _a.defaultEmail, defaultEmail = _b === void 0 ? '' : _b, _c = _a.defaultPhone, defaultPhone = _c === void 0 ? '' : _c;
    // Create schemas at runtime - ✅ t() called when hook is used
    var errorMessages = getErrorMessages();
    var emailSchema = Joi.string()
        .email({ tlds: { allow: false } })
        .messages(errorMessages.email);
    var schema = Joi.object({
        email: emailSchema.allow(''),
        phone: Joi.string().allow('').custom(validatePhone, 'Phone validation').messages(errorMessages.phone),
        agree: Joi.boolean().valid(true).required().messages(errorMessages.agree),
    });
    var form = useForm({
        mode: 'onChange',
        defaultValues: {
            email: defaultEmail,
            phone: defaultPhone,
            agree: false,
        },
        resolver: joiResolver(schema),
    });
    return form;
};
